import { IconBrandWhatsapp, IconExternalLink, IconLink, IconQrcode, IconShare } from "@tabler/icons-react";
import { _showToast } from "../../../toastHelper";
import { useRef, useState } from "react";
import { QrCode } from "react-qrcode-pretty";
import download from 'downloadjs';

export default function MyQRCode({ url }) {
    const [canvas, setCanvas] = useState(null);

    const handleCopyClick = () => {
        navigator.clipboard.writeText(url);
        _showToast("Copied successfully.", "success");
    };

    const handleShareviaWhatsapp = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`, '_blank')
    }

    return (<div className="row">
        <div className="col-12 mb-4">
            <div className="p-3 card">
                <div className="align-items-center row">
                    <div className="col-12 col-md-6">
                        <div className="p-3">
                            <h5 className="card-title fs-15 ms-2">My QR Code</h5>
                            <img src="/images/gallery.png" className="img-fluid " style={{ borderRadius: "10px" }}></img>
                        </div>
                    </div>
                    {url != "" && (
                        <div className="col-12 col-md-6">
                            <div className="d-flex flex-column align-items-center">
                                <div>
                                    <div id="qr-code" className="event-qr-code">
                                        <QrCode
                                            variant={{
                                                eyes: 'standard',
                                                body: 'dots'
                                            }}
                                            value={url}
                                            padding={150}
                                            margin={30}
                                            canvasProps={{
                                                style: {
                                                    width: "200px",
                                                    height: "200px"
                                                }
                                            }}
                                            size={2000}
                                            onReady={setCanvas}
                                            bgRounded
                                            divider></QrCode>
                                    </div>
                                </div>
                                <div className="my-gallery-link">
                                    <a href={url} target="_blank">{url} <IconExternalLink className="ms-1" size={17} stroke={1} />
                                    </a>
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-primary mt-3"
                                        onClick={() => !!canvas && download(canvas.toDataURL('png'), 'my_qr_code.png', 'image/png')}>
                                        <IconQrcode className="me-1" size={17} />Download QR Code
                                    </button>
                                    <div className="dropdown" data-bs-toggle="dropdown">
                                        <div>
                                            <button className="btn btn-success mt-3"><IconShare className="me-1" size={17} />Share
                                            </button>
                                        </div>
                                        <div role="menu" aria-hidden="false" className="dropdown-menu" data-popper-placement="bottom-start"
                                            style={{ position: "absolute", inset: "0px auto auto 0px", transform: "translate(0px, 55px)" }}>
                                            <button type="button" role="menuitem" className="dropdown-item" onClick={handleCopyClick}><IconLink className="me-1" size={17} />Copy Link</button>
                                            <button type="button" role="menuitem" className="dropdown-item" onClick={handleShareviaWhatsapp}><IconBrandWhatsapp className="me-1" size={17} />Share Via WhatsApp</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>)
}